//Backend URL (already includes /api/v1, so endpoints below start with "/")

//local
//export const API_BASE_URL = "http://127.0.0.1:8080/api/v1";

//Staging
export const API_BASE_URL = "https://api-supplier.virtualtoactual.cloud/api/v1";

//Live
//export const API_BASE_URL = "https://api-supplier-test.v2a.digital/api/v1";

// Raw error log files are served from the backend host root, e.g. https://api-supplier.virtualtoactual.cloud/error-logs/<log_file>
export const ERROR_LOG_FILE_BASE_URL = `${API_BASE_URL.replace(/\/api\/v1\/?$/, "")}/error-logs`;

const withQuery =(path: string, qs?: string) => (qs ? `${path}?${qs}` : path);

// list / details / create / update / delete for a REST resource at `base`
const crud = (base: string) => ({
  list: (qs?: string) => withQuery(base, qs),
  details: (id: number | string) => `${base}/${id}`,
  create: base,
  update: (id: number | string) => `${base}/${id}`,
  delete: (id: number | string) => `${base}/${id}`,
});

export const SUPPLIER_BACKEND_API_ENDPOINTS = {
  authentication: {
    login: "/users/login",
    verifyToken: "/users/verify-token",
    menuAccess: (roleCode: number | string) =>
      withQuery("/users/menu-access", `role_code=${roleCode}`),
    changePasswordLink: "/users/change-password-link",
  },

  suppliers: crud("/suppliers"),
  agents: crud("/agents"),
  vendors: crud("/vendors"),
  flights: crud("/flights"),

  inventory: {
    ...crud("/inventory"),
    fareSearch: "/inventory/fare-search",
    fareCheck: "/inventory/fare-check",
  },

  supplierWallet: {
    transactions: (qs?: string) =>
      withQuery("/wallet/supplier/transactions", qs),
  },

  common: {
    uploadFile: "/common/upload",
  },

  reports: {
    dashboard: "/reports/dashboard",
  },

  airlines: crud("/airlines"),
  airports: crud("/airports"),

  countries: crud("/location/countries"),
  states: crud("/location/states"),
  cities: crud("/location/cities"),
  pincode: {
    ...crud("/location/pincode"),
    detail: (pin: number | string) =>
      withQuery("/location/pincode", `pin=${pin}`),
  },

  rbacRoles: crud("/rbac/roles"),
  rbacModules: crud("/rbac/modules"),
  rbacMenus: crud("/rbac/menus"),
  rbacRoleModulesAccess: crud("/rbac/role-module-access"),
  walletTopup: {
    ...crud("/wallet/requests"),
    details: (request_ref: number | string) =>
      `${"/wallet/requests"}/${request_ref}`, //GET
    approve: (request_ref: number | string) =>
      `${"/wallet/requests"}/${request_ref}/approve`, //PUT
    reject: (request_ref: number | string) =>
      `${"/wallet/requests"}/${request_ref}/reject`, //PUT
  },
  logs: {
    errors: (qs?: string) => withQuery("/logs/errors", qs),
    errorDetails: (id: number | string) => `/logs/errors/${id}`,
    serviceApi: (qs?: string) => withQuery("/logs/service-api", qs),
    serviceApiDetails: (id: number | string) => `/logs/service-api/${id}`,
  },
  notifications: {
    ...crud("/notifications"),
    unreadCount: "/notifications/unread-count",
    markAllRead: "/notifications/mark-all-read",
    singleMarkRead: (notificationId: number | string) =>
      `${"/notifications"}/${notificationId}/read`,
  },
};
